import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * One-line privacy promise for data-entry cards.
 * "At every point of vulnerability."
 */
export default function DataPrivacyPromise() {
  const navigate = useNavigate();
  return (
    <p
      style={{
        fontSize: 10,
        color: 'var(--muted)',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        marginTop: 12,
        marginBottom: 0,
        lineHeight: 1.4,
      }}
    >
      <span>🔒</span>
      <span>
        Your data is never sold or shared with employers, insurers, or advertisers.
        <button
          type="button"
          onClick={() => navigate('/about')}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            marginLeft: 4,
            textDecoration: 'underline',
            cursor: 'pointer',
            color: 'inherit',
            fontSize: 'inherit',
            fontFamily: 'inherit',
          }}
        >
          Our promise →
        </button>
      </span>
    </p>
  );
}
